export const AVAILABILITY_SETTING_STRUCTURES = "/api/availability-settings-per-structure"
export const AVAILABILITY_SETTING_STRUCTURE = "/api/availability-settings-per-structure/:param"
